import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

const CollapsibleItemsList = ({
  items = [],
  maxVisible = 1,
  onRemove,
  title,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => setIsModalOpen(!isModalOpen);

  if (!items || items.length === 0) {
    return null;
  }

  const visibleItems = items.slice(0, maxVisible);
  const hiddenItems = items.slice(maxVisible);
  const hasHiddenItems = hiddenItems.length > 0;

  return (
    <div
      className="d-flex flex-wrap align-items-center mb-2"
      style={{ gap: '8px' }}
    >
      {visibleItems.map((item) => (
        <div
          key={item.id}
          className="d-flex align-items-center justify-content-between rounded-pill me-2"
          style={{
            backgroundColor: '#DBEAFE',
            color: 'rgb(30 64 175)',
            fontSize: '0.85rem',
            maxWidth: 'max-content',
            padding: '6px 10px',
          }}
        >
          <span className="text-nowrap me-2" style={{ lineHeight: '1' }}>
            {item.name}
          </span>
          {onRemove && (
            <i
              className="mdi mdi-close ml-1"
              style={{
                fontSize: '0.95rem',
                cursor: 'pointer',
                color: 'crimson',
              }}
              onClick={(e) => {
                e.stopPropagation();
                onRemove(item.id);
              }}
            ></i>
          )}
        </div>
      ))}

      {hasHiddenItems && (
        <div
          className="rounded-pill"
          style={{
            backgroundColor: '#E5E7EB',
            color: 'black',
            padding: '6px 10px',
            fontSize: '0.85rem',
            maxWidth: 'max-content',
            padding: '6px 10px',
            width: 'max-conent',
            fontWeight: 600,
            cursor: 'pointer',
            lineHeight: 1,
          }}
          onClick={toggleModal}
        >
          +{hiddenItems.length}
        </div>
      )}

      <Modal isOpen={isModalOpen} toggle={toggleModal}>
        <ModalHeader
          toggle={toggleModal}
          close={
            <i
              className="mdi mdi-close"
              onClick={toggleModal}
              style={{ fontSize: '22px', cursor: 'pointer' }}
            />
          }
          className="d-flex align-items-center no-margin-modal-title"
          style={{
            marginTop: 0,
            paddingTop: '0.75rem',
            height: 'max-content',
          }}
        >
          {title}
        </ModalHeader>
        <ModalBody>
          <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
            <div className="d-flex flex-wrap" style={{ gap: '8px' }}>
              {items.map((item) => (
                <div
                  key={item.id}
                  className="d-flex align-items-center justify-content-between"
                  style={{
                    backgroundColor: '#DBEAFE',
                    color: 'rgb(30 64 175)',
                    borderRadius: '20px',
                    padding: '4px 12px',
                    maxWidth: 'max-content',
                    fontSize: '0.95rem',
                    marginBottom: '8px',
                  }}
                >
                  <span className="text-nowrap">{item.name}</span>
                  {onRemove && (
                    <i
                      className="mdi mdi-close ml-1"
                      style={{
                        fontSize: '1.2rem',
                        cursor: 'pointer',
                        color: 'crimson',
                        marginTop: '-2px',
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        onRemove(item.id);
                      }}
                    ></i>
                  )}
                </div>
              ))}
            </div>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default CollapsibleItemsList;
